import { render, staticRenderFns } from "./FileAuth.vue?vue&type=template&id=4c80f5c5&scoped=true"
import script from "./FileAuth.vue?vue&type=script&lang=ts"
export * from "./FileAuth.vue?vue&type=script&lang=ts"
import style0 from "./FileAuth.vue?vue&type=style&index=0&id=4c80f5c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80f5c5",
  null
  
)

export default component.exports